import React from 'react';
import {
  Button, Paper, Stack, Typography,
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PageLayout from '../shell/PageLayout';
import { useOperations } from './OperationsProvider';
import { callInQueue, humanMs } from './areas';
import OperationsStatus from './OperationsStatus';
import { EmptyState } from './FeedState';

export default function ParkingQueuePage() {
  const { data, trips, updatedAt, error } = useOperations();
  const [params] = useSearchParams(); const navigate = useNavigate();
  const areas = (data.areas || []).filter((a) => !params.get('area') || String(a.id) === params.get('area'));
  const rows = callInQueue(areas, trips, data.vehicles);
  return (
    <PageLayout title="Outside parking" subtitle="Current parking occupants, longest wait first. Includes trucks with and without an open trip.">
      <OperationsStatus />
      {!rows.length && <EmptyState updatedAt={updatedAt} unavailable={error} empty="No vehicles parked here." />}
      {rows.map((row) => (
        <Paper key={`${row.vehicleId}-${row.area}`} variant="outlined" sx={{ p: 2, mb: 1 }}>
          <Stack direction="row" justifyContent="space-between" gap={1}>
            <div>
              <Typography fontWeight={600}>{row.vehicle}</Typography>
              <Typography>{`${row.area} · ${humanMs(row.waitingMs)}${row.stale ? ' · Position stale' : ''}`}</Typography>
            </div>
            <Button onClick={() => navigate(row.trip ? `/trips/${row.trip.id}` : '/yard-intake')}>{row.trip ? 'Open trip' : 'Admit truck'}</Button>
          </Stack>
        </Paper>
      ))}
    </PageLayout>
  );
}
